import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from "@angular/core";
import { MatMenuTrigger } from "@angular/material";

@Component({
	selector: "app-context-menu",
	templateUrl: "./context-menu.component.html",
	styleUrls: ["./context-menu.component.css"],
})
export class ContextMenuComponent implements OnInit {
	@Input()
	contextMenuItems: Array<any>;

	@Output()
	onContextMenuItemClick: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild("menuTrigger", { static: true }) menu: MatMenuTrigger;

	ngOnInit() {
		// console.log(this.menu);
		// this.menu.openMenu();
		// console.log(this.menu.menuOpened);
	}

	onContextMenuClick(event, data): any {
		this.onContextMenuItemClick.emit({
			event,
			data,
		});
	}






// ContextMenu.prototype.draw = function() {
//     var div = this.div_;
//     div.style.left = '0px';
//     div.style.top = '0px';
//     div.style.width = '100px';
//     div.style.height = '50px';
// };

}



